// extracted by mini-css-extract-plugin
export default {"container":"tab-group_container__ENw5r"};